<script lang="ts">
  export type BadgeVariant = 'default' | 'primary' | 'success' | 'danger' | 'warning' | 'info' | 'category' | 'source-user' | 'source-auto' | 'source-ai' | 'source-rule' | 'subscription' | 'bill' | 'due-soon' | 'overdue' | 'not-due';
  export type BadgeSize = 'sm' | 'md' | 'lg';

  let {
    variant = 'default',
    size = 'md',
    title = undefined as string | undefined,
    children
  }: {
    variant?: BadgeVariant;
    size?: BadgeSize;
    title?: string;
    children: any;
  } = $props();
</script>

<span
  class="badge"
  class:default={variant === 'default'}
  class:primary={variant === 'primary'}
  class:success={variant === 'success'}
  class:danger={variant === 'danger'}
  class:warning={variant === 'warning'}
  class:info={variant === 'info'}
  class:category={variant === 'category'}
  class:source-user={variant === 'source-user'}
  class:source-auto={variant === 'source-auto'}
  class:source-ai={variant === 'source-ai'}
  class:source-rule={variant === 'source-rule'}
  class:subscription={variant === 'subscription'}
  class:bill={variant === 'bill'}
  class:due-soon={variant === 'due-soon'}
  class:overdue={variant === 'overdue'}
  class:not-due={variant === 'not-due'}
  class:sm={size === 'sm'}
  class:md={size === 'md'}
  class:lg={size === 'lg'}
  {title}
>
  {@render children()}
</span>

<style lang="scss">
  .badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-sm);
    font-weight: var(--font-weight-semibold);
    white-space: nowrap;
    transition: all var(--transition-fast);

    // Sizes
    &.sm {
      padding: 3px var(--spacing-sm);
      font-size: var(--font-size-xxs);
      letter-spacing: 0.3px;
    }

    &.md {
      padding: var(--spacing-xs) var(--spacing-sm);
      font-size: var(--font-size-xs);
    }

    &.lg {
      padding: var(--spacing-sm) var(--spacing-md);
      font-size: var(--font-size-sm);
    }

    // Variants
    &.default {
      background: var(--color-background-tertiary);
      color: var(--color-text-secondary);
    }

    &.primary {
      background: var(--color-primary-light);
      color: var(--color-primary-dark);
    }

    &.success {
      background: var(--color-success-light);
      color: var(--color-success-dark);
    }

    &.danger {
      background: var(--color-danger-light);
      color: var(--color-danger-dark);
    }

    &.warning {
      background: var(--color-warning-light);
      color: var(--color-warning-dark);
    }

    &.info {
      background: var(--color-primary-light);
      color: var(--color-primary-dark);
    }

    &.category {
      background: var(--color-primary-light);
      color: var(--color-primary-dark);
    }

    // Source badges (for categorization source)
    &.source-user,
    &.source-auto,
    &.source-ai,
    &.source-rule {
      padding: 3px var(--spacing-sm);
      font-size: var(--font-size-xxs);
      text-transform: uppercase;
      letter-spacing: 0.3px;
    }

    &.source-user {
      background: var(--color-primary-light);
      color: var(--color-primary-dark);
    }

    &.source-auto {
      background: var(--color-border);
      color: var(--color-text-tertiary);
    }

    &.source-ai {
      background: var(--color-primary-light);
      color: var(--color-purple-hover);
    }

    &.source-rule {
      background: var(--color-warning-light);
      color: var(--color-warning-dark);
    }

    // Recurring type badges
    &.subscription {
      background: var(--color-primary-light);
      color: var(--color-primary-dark);
    }

    &.bill {
      background: var(--color-warning-light);
      color: var(--color-warning-dark);
    }

    // Recurring status badges
    &.due-soon {
      background: var(--color-warning-light);
      color: var(--color-warning-dark);
    }

    &.overdue {
      background: var(--color-danger-light);
      color: var(--color-danger-dark);
    }

    &.not-due {
      background: var(--color-background-tertiary);
      color: var(--color-text-tertiary);
    }
  }
</style>
